import { pixleeURL } from './constants';

function getStringTemplate ({
	albumId, page = 1, perPage = 24, filters = {}
}) {

	return `${pixleeURL}/api/v2/albums/${albumId}/photos?page=${page}&per_page=${perPage}
	&api_key=6RnR9XarqCQlbcsek45O&filters=${filters}&timestamp=${Date.now()}`;

}

export default getStringTemplate;
